import { createLocalStorageItem } from 'src/domains/layouts/state/localStorage/createLocalStorageItem';
import { LocalStorageItemState } from 'src/domains/layouts/state/localStorage/LocalStorageItemState';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';
import * as t from 'io-ts';

const decodeIO = t.boolean;
const decode = buildValidator('localStorage.newPlaceBet', decodeIO, true);

export const localStorageNewPlaceBet = (withAutorun: boolean, key: string): LocalStorageItemState<boolean> => {
    return createLocalStorageItem(withAutorun, {
        key: key,
        decode: decode,
        defaultValue: false,
    });
};
